import { Flex, Heading } from '@chakra-ui/react'
import React from 'react'
import ProjectCard from '../Components/ProjectCard'
import styles from "../CSS_Files/Projects.module.css"
import Pro1 from "../Images/Objectopedia.png"
import Pro2 from "../Images/carter.png"
import Pro3 from "../Images/fitbuddies.png"
import Pro4 from "../Images/survey.png"
import Pro5 from "../Images/decorDash.png"
const Projects = () => {

  const projects = [
    {
      img:Pro5,
      title:`Decor Dash`,
      desc:"The project is an e-commerce furniture website that aims to provide customers with a convenient and user-friendly platform for purchasing furniture online.",
      stacks:"ReactJS, Redux, NodeJS, ExpressJS, MongoDB, Mongoose",
      github:"https://github.com/RitikSingh11661/noble-weather-6049",
      app:"https://decordash.vercel.app/"
    },
    {
      
      img:Pro1,
      title:`Object"o"Pedia`,
      desc:"An e-Commerce website where one can able to buy daily lifestyle products. Design and tech focussed homegrown lifestyle accessories brand inspiring everyday possibilities.",
      stacks:"HTML, CSS, JavaScript, React, Redux, ChakraUI, firebase",
      github:"https://github.com/SubodhSingh8543/Object-o-pedia",
      app:"https://zippy-question-7549.vercel.app/"
    },
    {
    
      img:Pro2,
      title:`Little Cart`,
      desc:"An e-Commerce website where one can buy children's related products. Design and tech focussed homegrown lifestyle accessories brand inspiring everyday possibilities.  ",
      stacks:"HTML, CSS, JavaScript, React, ChakraUI",
      github:"https://github.com/AnkitChopde/impossible-basin-3215",
      app:"https://impossible-basin-3215-ankitchopde.vercel.app/"
    },
    {
  
      img:Pro3,
      title:`Fit Buddies`,
      desc:"The project is a fitness website designed to provide users with a comprehensive platform for fitness and wellness information, resources, and services. ",
      stacks:"HTML, CSS, JavaScript ",
      github:"https://github.com/eraltafs/Fit-Buddy",
      app:"https://eager-structures.netlify.app/"
    },
    {
  
      img:Pro4,
      title:`SurveyMonkey Clone`,
      desc:"SurveyMonkey is online survey software that helps you to create and run professional online surveys. It provides various survey templates for different purposes.",
      stacks:"HTML, CSS, JavaScript",
      github:"https://github.com/AnkitChopde/modest-invention-5857",
      app:"https://glowing-rolypoly-3a6351.netlify.app/"
    },
    {

      img:"https://github.com/nitinkondhari03/hackthon_virtual-/assets/112820279/1f89e9b0-cefe-4157-ac8c-1753fffe8543",
      title:`Snake & Ladder Game`,
      desc:"The snake and ladder game is an exciting and engaging game that provides players with a fun and challenging gaming experience.It is an multiplayer game.",
      stacks:"ReactJS, NodeJS, ExpressJS, MongoDB, TypeScript, Tailwind",
      github:"https://github.com/nitinkondhari03/hackthon_virtual-",
      app:"https://snakeladders.netlify.app/"
    }
  ]
  return (
    <div id="projects" m style={{backgroundColor:"#152242",padding:"2rem"}}>
       <Heading mt="10" mb="6" className={styles.heading}>My Creative Projects</Heading>
       <Flex flexWrap={"wrap"} justifyContent="center"
              
              gap={7}
             >
                 {
                  projects.map((el,i)=>(
                    <ProjectCard {...el} key={i}/>
                  ))
                 }
            </Flex>
            
    </div>
  )
}

export default Projects
